"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MethodCallResult = void 0;
var MethodCallResult;
(function (MethodCallResult) {
    MethodCallResult["TRUE"] = "TRUE";
    MethodCallResult["FALSE"] = "FALSE";
    MethodCallResult["OTHER_FAILURE"] = "OTHER_FAILURE";
})(MethodCallResult = exports.MethodCallResult || (exports.MethodCallResult = {}));
